var map = {
	"./Aixin_Tian.png": 8083,
	"./Daiyun_Han.png": 2012,
	"./Guozhen_Fu.png": 8914,
	"./Jianwei_Wang.png": 6829,
	"./Jinjia_Li.png": 7473,
	"./Kai_Wang.png": 8731,
	"./Li_Yi.png": 2510,
	"./Shanqi_Han.png": 423,
	"./Xuejiao_Wang.png": 2779
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7292;